import React from "react";
import "./style.scss";
import { PlayStore } from "../../Icons/playStory";
import { AppStore } from "../../Icons/appstore";
import { useContent } from "../../i18n";

export const WelcomeHeader = () => {
  const { hero } = useContent();

  return (
    <div className="main-header">
      <div className="main-header-wrapper ">
        <div className="container header-container">
          <div className="main-right-header">
            <div className="text-wrapper-bg">
              <div className="header-text">
                <h2>{hero.title}</h2>
                <p>{hero.text}</p>
              </div>
            </div>
            <p className="text-marketing">{hero.marketing}</p>
            <div className="hero-ctas">
              <a className="hero-cta" href="#providers">
                {hero.cta}
              </a>
              <a className="hero-cta ghost" href="/journey.html">
                {hero.journey}
              </a>
            </div>
            <p className="apps-label">{hero.appsLabel}</p>
            <div className="app-links">
              <a>
                <AppStore />
              </a>
              <a>
                <PlayStore />
              </a>
            </div>
          </div>
          <div className="main-left-header">
            <div className="left-img one">
              <img src="/assets/mobile1.png" alt="" />
            </div>
            <div className="left-img two">
              <img src="/assets/mobile2.png" alt="" />
            </div>
            <div className="left-img three">
              <img src="/assets/mobile3.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
